import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminAuthGate from './AdminAuthGate';
import ResetPassword from './ResetPassword';
import { setAdminLang, loadStoredAdminLang } from '../../i18n/adminT';

export default function AdminApp() {
  // Schermate prima del login (es. reset password): ultima lingua usata in questo browser
  setAdminLang(loadStoredAdminLang());
  return (
    <Routes>
      <Route path="reset-password" element={<ResetPassword />} />
      <Route path="*" element={<AdminAuthGate />} />
    </Routes>
  );
}
